<template>
  <div class="user-bar">
    <a-dropdown class="user panel-item">
      <div class="user-avatar">
        <SmartAvatar :src="userInfo.avatar"
                     style="display: flex; flex-direction: row; align-items: center; justify-content: center"/>
        <label>{{ userName }}</label>
        <slot name="avaOtherContent"></slot>
      </div>
      <template #overlay>
        <a-menu>
          <a-menu-item key="clearCache" @click="handleUser('clearCache')">
            <loading3-quarters-outlined style="margin-right: 8px"/>
            <span>清理缓存</span>
          </a-menu-item>
          <a-menu-divider/>
          <a-menu-item key="outLogin" @click="handleUser('outLogin')">
            <export-outlined style="margin-right: 8px"/>
            <span>退出登录</span>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
    <slot name="barOtherContent"></slot>
    <div class="screen panel-item hidden-sm-and-down" @click="fullscreen">
      <fullscreen-outlined/>
    </div>
  </div>
</template>
<script>
import {createVNode, getCurrentInstance} from 'vue'
import {ExclamationCircleOutlined} from '@ant-design/icons-vue'
import {message} from 'ant-design-vue'
import {tool} from 'elead-ui-tool-v3'
import ssoApi from '@/api/auth/sso2Api'
import * as sso from "@/utils/sso"
import screenfull from 'screenfull'
export default {
  name: 'UserBar',
  components: {},
  data() {
    return {
      lang: [],
      userInfo: {},
      userName: '',
      userNameF: ''
    }
  },
  watch: {
    userInfoWatch(newVal, oldVal) {
      this.userInfo = newVal
    }
  },
  created() {
    const {proxy} = getCurrentInstance()
    this.userInfo = proxy.$TOOL.data.get('USER_INFO')
    this.userName = this.userInfo.userName
    // 获取默认语言
    this.lang = new Array(this.$TOOL.data.get('APP_LANG') || this.$CONFIG.LANG)
    this.userInfo = this.$TOOL.data.get('USER_INFO')
    this.userNameF = this.userName.substring(0, 1)
  },
  methods: {
    // 个人信息
    handleUser(key) {
      if (key === 'clearCache') {
        this.$confirm({
          title: '提示',
          content: '确认清理所有缓存？',
          icon: createVNode(ExclamationCircleOutlined),
          maskClosable: false,
          okText: '确定',
          cancelText: '取消',
          onOk() {
            message.loading('正在清理中...', 1)
            tool.data.clear()
            setTimeout(() => {
              sso.toLogin()
            }, 100)
          },
          onCancel() {
          }
        })
      }
      if (key === 'outLogin') {
        this.$confirm({
          title: '提示',
          content: '确认退出当前用户？',
          icon: createVNode(ExclamationCircleOutlined),
          maskClosable: false,
          onOk() {
            // 取得缓存中的token
            const token = tool.data.get('TOKEN')
            const param = {
              token: token
            }
            message.loading('退出中...', 0)
            ssoApi
                .logout(param)
                .then(() => {
                  // message.c
                  // 清理掉个人的一些信息
                  tool.data.remove('TOKEN')
                  tool.data.remove('USER_INFO')
                  tool.data.remove('MENU')
                  tool.data.remove('PERMISSIONS')
                  sso.toLogin()
                })
                .catch(() => {
                  tool.data.clear()
                  sso.toLogin()
                })
          },
          onCancel() {
          }
        })
      }
    },
    // 设置多语言语种
    handleIn18(key) {
      this.lang = []
      this.lang.push(key)
      this.$i18n.locale = key
      this.$TOOL.data.set('APP_LANG', key)
    },
    // 全屏
    fullscreen() {
      const element = document.documentElement
      if (screenfull.isEnabled) {
        screenfull.toggle(element)
      }
    }
  }
}
</script>
<style lang="less" scoped>
:deep(.ant-modal) {
  top: 20px;
}
:deep(.ant-modal-content) {
  border-radius: 10px;
}
.user-bar {
  display: flex !important;
  align-items: center;
  height: 100%;
}
.user-bar .panel-item {
  padding: 0 10px;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
}
.user-bar .panel-item i {
}
.user-bar .panel-item:hover {
  background: var(--header-color-split);
}
.user-bar .user-avatar {
  height: 49px;
  display: flex;
  align-items: center;
}
.user-bar .user-avatar label {
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
  width: 60px;
}
</style>
